"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var path_utils_1 = require("@pinto/path-utils");
var getImmer_1 = tslib_1.__importDefault(require("./utils/getImmer"));
var validation_1 = require("./utils/validation");
var FormContext_1 = tslib_1.__importDefault(require("./FormContext"));
;
var defaultRegisteredFieldProps = {
    update: lodash_1.default.noop,
    parse: lodash_1.default.identity,
    format: lodash_1.default.identity,
    validate: lodash_1.default.noop,
};
/** @deprecated @pinto/react-form is not needed anymore, just use MobX */
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form(props) {
        var e_1, _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            version: 0,
            immer: getImmer_1.default(),
            getFormState: function () { return _this.formState; },
            getFormProps: function () { return _this.getFormProps(); },
            getValue: function () { return _this.formState.value; },
        };
        _this.formState = {
            valid: true,
            value: _this.props.initialValues || {},
            fields: {},
            instanceMap: new WeakMap,
            events: {},
            meta: {},
        };
        var toBind = [
            'changeField',
            'getArrayFieldProps',
            'getErrors',
            'getFieldProps',
            'getFieldsProps',
            'registerEvent',
            'registerEventOnce',
            'registerField',
            'touchFields',
        ];
        var _loop_1 = function (key) {
            // @ts-ignore
            this_1.state[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _this[key].apply(_this, tslib_1.__spreadArray([], tslib_1.__read(args)));
            };
        };
        var this_1 = this;
        try {
            for (var toBind_1 = tslib_1.__values(toBind), toBind_1_1 = toBind_1.next(); !toBind_1_1.done; toBind_1_1 = toBind_1.next()) {
                var key = toBind_1_1.value;
                _loop_1(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (toBind_1_1 && !toBind_1_1.done && (_a = toBind_1.return)) _a.call(toBind_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _this.applyValidation(_this.formState.value, _this.props.validate);
        return _this;
    }
    Form.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.initialValues !== this.props.initialValues) {
            this.formState.value = this.props.initialValues || {};
            this.updateFieldsForPaths(lodash_1.default.map(this.formState.fields, function (v, key) { return lodash_1.default.toPath(key); }));
            this.setState({ version: this.state.version + 1 });
        }
        if (prevProps.validate !== this.props.validate) {
            this.applyValidation(this.formState.value, this.props.validate);
            if (!lodash_1.default.isEmpty(this.formState.meta)) {
                this.updateFieldsForPaths(lodash_1.default.map(this.formState.meta, function (v, path) { return lodash_1.default.toPath(path); }));
            }
        }
    };
    Form.prototype.registerEvent = function (instance, event, callback) {
        var events = this.formState.events;
        var unregister = function () {
            for (var key in events) {
                events[key] = events[key].filter(function (h) { return h.instance !== instance; });
            }
        };
        // Firstly remove the instance from all other events
        unregister();
        events[event] = events[event] || [];
        events[event].push({ instance: instance, callback: callback });
        if (event === 'init')
            callback(tslib_1.__assign({}, this.getFormProps()));
        return unregister;
    };
    Form.prototype.registerEventOnce = function (instance, event, callback) {
        var unregister = this.registerEvent(instance, event, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            callback.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args)));
            unregister();
        });
        return unregister;
    };
    Form.prototype.registerField = function (originalNames, instance, props) {
        var e_2, _a;
        var _this = this;
        var names;
        if (typeof originalNames === 'string')
            names = [originalNames];
        else if (Array.isArray(originalNames))
            names = originalNames;
        else
            names = Object.values(originalNames);
        names = names.filter(function (n) { return n != null; }).map(path_utils_1.normalizePath);
        var unmount = function () {
            var e_3, _a;
            var fields = _this.formState.fields;
            try {
                for (var names_2 = tslib_1.__values(names), names_2_1 = names_2.next(); !names_2_1.done; names_2_1 = names_2.next()) {
                    var name_1 = names_2_1.value;
                    if (!fields[name_1])
                        continue;
                    fields[name_1] = fields[name_1].filter(function (item) { return item !== instance; });
                    if (!fields[name_1].length) {
                        delete _this.formState.meta[name_1];
                        _this.formState.instanceMap.delete(instance);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (names_2_1 && !names_2_1.done && (_a = names_2.return)) _a.call(names_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        // Remove the instance from all other events if its names change
        var existing = this.formState.instanceMap.get(instance);
        if (existing) {
            if (!lodash_1.default.isEqual(originalNames, existing.originalNames))
                unmount();
        }
        var fields = this.formState.fields;
        try {
            for (var names_1 = tslib_1.__values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
                var name_2 = names_1_1.value;
                fields[name_2] = fields[name_2] || [];
                if (!fields[name_2].find(function (item) { return item === instance; })) {
                    fields[name_2].push(instance);
                    if (!existing)
                        this.updateMeta(name_2, { touched: false });
                    var propsWithDefaults = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ name: name_2,
                        names: names,
                        originalNames: originalNames }, defaultRegisteredFieldProps), { update: function () { return instance.forceUpdate(); } }), props);
                    this.formState.instanceMap.set(instance, propsWithDefaults);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (names_1_1 && !names_1_1.done && (_a = names_1.return)) _a.call(names_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return unmount;
    };
    Form.prototype.eachEvent = function (name, callback) {
        var e_4, _a;
        try {
            for (var _b = tslib_1.__values(this.formState.events[name] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var event_1 = _c.value;
                callback(event_1.callback, event_1);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    Form.prototype.applyValidation = function (formValue, validator) {
        var _this = this;
        this.formState.valid = true;
        lodash_1.default.forEach(this.formState.meta, function (meta) { delete meta.error; });
        if (!validator)
            return;
        var errors = validation_1.applyValidation(formValue, validator).errors;
        this.formState.valid = lodash_1.default.isEmpty(errors);
        lodash_1.default.forEach(errors, function (err, path) { return _this.setError(path, err); });
    };
    Form.prototype.getErrors = function (formMeta) {
        if (formMeta === void 0) { formMeta = this.formState.meta; }
        var errors = {};
        lodash_1.default.forEach(formMeta, function (meta, path) {
            if (meta.error)
                errors[path] = meta.error;
        });
        return errors;
    };
    Form.prototype.getFormProps = function () {
        var _this = this;
        return {
            valid: this.formState.valid,
            formValue: this.formState.value,
            getFormValue: function () { return _this.formState.value; },
            context: this.state,
        };
    };
    Form.prototype.getFirstFieldPropsForName = function (name) {
        var result;
        var bucket = this.formState.fields[name];
        if (bucket === null || bucket === void 0 ? void 0 : bucket.length)
            result = this.formState.instanceMap.get(bucket[0]);
        return result || tslib_1.__assign({ name: name, names: [name], originalNames: name }, defaultRegisteredFieldProps);
    };
    Form.prototype.changeField = function (name, value) {
        if (value && value.nativeEvent && value.nativeEvent instanceof Event) {
            value = value.target.value;
        }
        return this.changeFieldProduce({
            name: name,
            mutate: function () { return value; },
            allowUndefined: true,
        });
    };
    Form.prototype.changeFieldProduce = function (_a) {
        var e_5, _b;
        var _this = this;
        var name = _a.name, mutate = _a.mutate, _c = _a.allowUndefined, allowUndefined = _c === void 0 ? false : _c;
        var immer = this.state.immer;
        var _d = this.props, validate = _d.validate, debug = _d.debug;
        var groupName = "change: " + name;
        var format = this.getFirstFieldPropsForName(name).format;
        if (debug) {
            console.group(groupName);
            console.info('name =', name);
        }
        var newValue;
        var handleUpdate = function (formValueDraft) {
            var currentDraft = formValueDraft;
            // You can change the root value by returning a new value entirely
            // This is rarely needed, usually it's actually a bug, but if you do need it, this is the method to do that
            var setReturnValue = function (newReturnValue) {
                currentDraft = newReturnValue;
                return currentDraft;
            };
            var options = tslib_1.__assign(tslib_1.__assign({ name: name, get formValueDraft() { return currentDraft; }, setReturnValue: setReturnValue, get formValue() { return immer.current(currentDraft); } }, lodash_1.default.omit(_this.getFormProps(), ['formValue', 'getFormValue'])), { getFormValue: function () { return immer.current(currentDraft); } });
            _this.eachEvent('pre:change', function (callback) { return callback(options); });
            _this.updateMeta(name, { touched: true });
            var oldValue = lodash_1.default.get(currentDraft, name);
            newValue = mutate(oldValue);
            if (!allowUndefined) {
                if (newValue === undefined)
                    newValue = oldValue;
                else if (newValue === immer.nothing)
                    newValue = undefined;
            }
            newValue = format(newValue);
            if (debug) {
                console.info('new value =', immer.isDraft(newValue) ? immer.current(newValue) : newValue);
                // console.info('new value is draft =', immer.isDraft(newValue));
                console.info('old value =', immer.isDraft(oldValue) ? immer.current(oldValue) : oldValue);
                console.info('old value === new value', oldValue === newValue);
            }
            lodash_1.default.set(currentDraft, name, newValue);
            _this.eachEvent('post:change', function (callback) { return callback(options); });
            return currentDraft;
        };
        var _e = tslib_1.__read(immer.produceWithPatches(this.formState.value, handleUpdate), 2), newFormValue = _e[0], patches = _e[1];
        this.formState.value = newFormValue;
        var metaPaths = this.updateMetaForFields([lodash_1.default.toPath(name)], newFormValue);
        if (validate) {
            var existingPatches = lodash_1.default.keyBy(patches.map(function (p) { return path_utils_1.toPathString(p.path); }));
            try {
                for (var metaPaths_1 = tslib_1.__values(metaPaths), metaPaths_1_1 = metaPaths_1.next(); !metaPaths_1_1.done; metaPaths_1_1 = metaPaths_1.next()) {
                    var path = metaPaths_1_1.value;
                    if (!existingPatches[path_utils_1.toPathString(path)]) {
                        patches.push({
                            op: 'add',
                            path: path,
                        });
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (metaPaths_1_1 && !metaPaths_1_1.done && (_b = metaPaths_1.return)) _b.call(metaPaths_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        var paths = this.updateFieldsForPaths(getPathsFromPatches(patches));
        if (debug) {
            console.info('patches(%d) =', patches.length);
            console.info(patches.map(function (x) { return "\t\u2192 " + x.op + " | " + path_utils_1.toPathString(x.path); }).join('\n'));
            console.info('patches =', patches);
            console.groupCollapsed("paths(" + paths.length + ")");
            console.info(paths.join('\n'));
            console.groupEnd();
            console.groupEnd();
        }
        this.eachEvent('post:update', function (callback) {
            return callback(tslib_1.__assign({ name: name, value: newValue, patches: patches,
                paths: paths }, _this.getFormProps()));
        });
    };
    Form.prototype.updateFieldsForPaths = function (paths) {
        var e_6, _a;
        var _b;
        var finalPaths = [];
        if (!paths.length)
            return [];
        if (!Array.isArray(paths[0]))
            throw new Error('only supports array paths');
        // makes parents update before children, potentially prunes child updates
        paths = Array.from(paths).sort();
        var processed = {};
        try {
            for (var paths_1 = tslib_1.__values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) { // trigger updates for all changed paths
                var path = paths_1_1.value;
                for (var i = 1; i <= path.length; ++i) { // trigger updates for every ancestor
                    var nextPath = path_utils_1.toPathString(path.slice(0, i));
                    if (processed[nextPath])
                        continue;
                    processed[nextPath] = true;
                    finalPaths.push(nextPath);
                    var bucket = this.formState.fields[nextPath] || [];
                    for (var j = 0; j < bucket.length; ++j) {
                        (_b = this.formState.instanceMap.get(bucket[j])) === null || _b === void 0 ? void 0 : _b.update();
                    }
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return finalPaths;
    };
    Form.prototype.updateMeta = function (path, diff) {
        var meta = this.formState.meta;
        if (!meta[path])
            meta[path] = { valid: true, touched: false };
        Object.assign(meta[path], diff);
    };
    Form.prototype.setError = function (path, error) {
        var diff = {
            valid: !error,
            error: error,
        };
        if (!diff.valid && this.props.touchOnError)
            diff.touched = true;
        this.updateMeta(path, diff);
    };
    /**
     * Update the compute .meta props for a given list of paths
     * Also runs the global form validation
     *
     * @param paths
     * @param [formValue=this.formState.value]
     */
    Form.prototype.updateMetaForFields = function (paths, formValue) {
        var e_7, _a;
        if (formValue === void 0) { formValue = this.formState.value; }
        var validate = this.props.validate;
        // run the global form validation
        this.applyValidation(formValue, validate);
        try {
            // run each individual field's validation and update the formState.meta
            for (var paths_2 = tslib_1.__values(paths), paths_2_1 = paths_2.next(); !paths_2_1.done; paths_2_1 = paths_2.next()) {
                var path = paths_2_1.value;
                var pathStr = path_utils_1.toPathString(path);
                var fieldValidate = this.getFirstFieldPropsForName(pathStr).validate;
                if (!fieldValidate)
                    continue;
                var value = lodash_1.default.get(this.formState.value, path);
                var _b = validation_1.getSingleValueValidationHandlers(value), check = _b.check, getError = _b.getError;
                fieldValidate({ value: value, check: check });
                var error = getError();
                this.setError(pathStr, error);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (paths_2_1 && !paths_2_1.done && (_a = paths_2.return)) _a.call(paths_2);
            }
            finally { if (e_7) throw e_7.error; }
        }
        // return paths for all fields that have changed
        return lodash_1.default.map(this.getErrors(), function (err, path) { return lodash_1.default.toPath(path); });
    };
    Form.prototype.baseGetFieldProps = function (_a) {
        var _this = this;
        var name = _a.name, format = _a.format, parse = _a.parse;
        var value = lodash_1.default.get(this.formState.value, name);
        //if (value == null) value = '';
        if (format)
            value = format(value);
        return {
            input: {
                name: name,
                value: value,
                onChange: function (value) {
                    return _this.changeField(name, parse ? parse(value) : value);
                },
                produce: function (mutate) {
                    return _this.changeFieldProduce({ name: name, mutate: mutate });
                },
            },
            meta: tslib_1.__assign({}, this.formState.meta[name]),
        };
    };
    Form.prototype.getFieldProps = function (instance) {
        return this.baseGetFieldProps(this.formState.instanceMap.get(instance));
    };
    Form.prototype.getFieldsProps = function (instance) {
        var e_8, _a;
        var _this = this;
        var originalNames = this.formState.instanceMap.get(instance).originalNames;
        if (Array.isArray(originalNames)) {
            var fields = {};
            // By sorting and reversing we ensure that child inputs override parents
            // e.g.
            //  names = [foo.bar, foo, foo.alpha, baz]
            //  fields = {
            //      foo: {
            //          alpha: { input },
            //          bar: { input },
            //      },
            //      baz: { input }
            //  }
            originalNames = Array.from(originalNames);
            originalNames.sort().reverse();
            try {
                for (var originalNames_1 = tslib_1.__values(originalNames), originalNames_1_1 = originalNames_1.next(); !originalNames_1_1.done; originalNames_1_1 = originalNames_1.next()) {
                    var name_3 = originalNames_1_1.value;
                    lodash_1.default.set(fields, name_3, this.baseGetFieldProps(tslib_1.__assign(tslib_1.__assign({}, defaultRegisteredFieldProps), { name: name_3 })));
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (originalNames_1_1 && !originalNames_1_1.done && (_a = originalNames_1.return)) _a.call(originalNames_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
            return fields;
        }
        if (lodash_1.default.isPlainObject(originalNames)) {
            return lodash_1.default.mapValues(originalNames, function (name) { return _this.baseGetFieldProps({ name: name }); });
        }
        console.warn('[Fields] Invalid names, must be an array or an object');
        return {};
    };
    Form.prototype.getArrayFieldProps = function (instance) {
        var _a;
        var _b = this.getFieldProps(instance), input = _b.input, meta = _b.meta;
        var length = ((_a = input.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
        var proxy = function (callback) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                input.produce(function (draft) {
                    return callback(Array.isArray(draft) ? draft : [], args);
                });
                return null;
            };
        };
        var mutateProxy = function (method) {
            return proxy(function (draft, args) {
                draft[method].apply(draft, tslib_1.__spreadArray([], tslib_1.__read(args)));
                return draft;
            });
        };
        var swap = proxy(function (draft, _a) {
            var _b = tslib_1.__read(_a, 2), fromIndex = _b[0], toIndex = _b[1];
            var _c = tslib_1.__read(draft.splice(fromIndex, 1), 1), removed = _c[0];
            draft.splice(toIndex, 0, removed);
            return draft;
        });
        var fields = {
            name: input.name,
            length: length,
            push: mutateProxy('push'),
            pop: mutateProxy('pop'),
            shift: mutateProxy('shift'),
            unshift: mutateProxy('unshift'),
            splice: mutateProxy('splice'),
            swap: swap,
            map: function (callback) {
                return lodash_1.default.range(length).map(function (index) { return callback(path_utils_1.joinPaths(input.name, index), index); });
            },
            remove: function (index) { return fields.splice(index, 1); },
        };
        return { fields: fields, meta: meta };
    };
    Form.prototype.touchFields = function (paths) {
        var _this = this;
        var pathArrays = paths.map(function (path) {
            _this.updateMeta(path, { touched: true });
            return lodash_1.default.toPath(path);
        });
        this.updateFieldsForPaths(this.updateMetaForFields(pathArrays));
    };
    Form.prototype.render = function () {
        return react_1.default.createElement(FormContext_1.default.Provider, tslib_1.__assign({ key: this.state.version }, this.props, { value: this.state }));
    };
    Form.propTypes = {
        initialValues: prop_types_1.default.object,
        debug: prop_types_1.default.bool,
        validate: prop_types_1.default.func,
        touchOnError: prop_types_1.default.bool,
    };
    Form.defaultProps = {
        initialValues: {},
        touchOnError: false,
    };
    return Form;
}(react_1.default.PureComponent));
exports.Form = Form;
var getPathsFromPatches = function (patches) {
    var paths = [];
    var iterator = function (path, value) {
        paths.push(path);
        if (lodash_1.default.isPlainObject(value)) {
            for (var key in value)
                iterator(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(path)), [key]), value[key]);
        }
        else if (Array.isArray(value)) {
            value.forEach(function (child, index) { return iterator(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(path)), [index]), child); });
        }
    };
    patches.forEach(function (patch) { return iterator(patch.path, patch.value); });
    return paths;
};
exports.default = Form;
//# sourceMappingURL=Form.js.map